import { Button, theme } from "antd";
import { useSelector, useDispatch } from "react-redux";
import type { RootState } from "../../../store";
import { setCollapsed } from "../../../redux/slices/customerSlice";
import { Header } from "antd/es/layout/layout";
import SelectDropdownCustSite from "../SelectDropdownCustSite";
import HeaderRightSide from "../HeaderRightSide";
import { useHeaderLogic } from "../hooks/useHeaderLogic";

interface AppHeaderProps {
    isMobile: boolean;
    isNewIndustry: boolean;
}

export default function AppHeader({ isMobile, isNewIndustry }: AppHeaderProps) {
    const dispatch = useDispatch();
    const { token: { colorBgContainer } } = theme.useToken();
    const { collapsed } = useSelector((state: RootState) => state.userInfo);

    const { lastSegment, mobileIcon, nonMobileIcon } = useHeaderLogic(isMobile, collapsed);

    const handleSiderClose = () => {
        dispatch(setCollapsed(!collapsed));
    };

    return (
        <Header
            className="header"
            style={{
                position: "sticky",
                top: 0,
                zIndex: 1,
                width: "100%",
                height: "64px",
                padding: "0 16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                background: colorBgContainer
            }}
        >
            <div className="collapseDiv">
                <Button
                    type="text"
                    icon={collapsed ? mobileIcon : nonMobileIcon}
                    onClick={handleSiderClose}
                    className="mr-10 text-base"
                />
                <SelectDropdownCustSite isNewIndustry={isNewIndustry} isMobile={isMobile} lastSegment={lastSegment} />
            </div>
            <HeaderRightSide />
        </Header>
    );
}